import { COST_CENTRE_MESSAGES } from 'core/centrocosto/constants/CostCentreMessages';
import { GENERIC_MESSAGES } from 'shared/constants/GenericMessages';
import { ApiError } from 'shared/http';

export class TemplateError {
  message: string;

  constructor(err: ApiError) {
    switch (err.status) {
      case 401:
        if (err.message === 'not allowed') {
          this.message = COST_CENTRE_MESSAGES.userNotAllowed;
        } else {
          this.message = GENERIC_MESSAGES.authenticationError;
        }
        break;
      case 403:
        if (err.message === 'no_access_to_cc') {
          this.message = COST_CENTRE_MESSAGES.noAccessToCc;
        } else {
          this.message = COST_CENTRE_MESSAGES.notAllowed;
        }
        break;
      default:
        this.message = GENERIC_MESSAGES.genericError;
    }
  }
}
